import { gql } from '@apollo/client/core';

export const CORPORATE_CLIENT_QUERY = gql`
  query ($slug: String, $bhClientId: Int) {
    corporateClient(slug: $slug, bhClientId: $bhClientId) {
      slug
      name
      logoImageURL
      hasYearsAhead
      isActive
    }
  }
`;

export const CORPORATE_CLIENTS_QUERY = gql`
  query {
    corporateClients {
      slug
      name
    }
  }
`;

export const CLIENT_SEARCH_QUERY = gql`
  query ($fragment: String!) {
    clientSearch(fragment: $fragment) {
      clientId
      clientName
    }
  }
`;

export const CORPORATE_SIGNUP_FORM_QUERY = gql`
  query ($slug: String!) {
    corporateClient(slug: $slug) {
      slug
      name
      logoImageURL
      hasYearsAhead
      isActive
      customFields {
        name
        displayName
        required
        ... on TextField {
          pattern
        }
        ... on SelectField {
          options
        }
      }
    }
  }
`;
